import { render, staticRenderFns } from "./Killist.vue?vue&type=template&id=7379356e&"
import script from "../killist.js?vue&type=script&lang=js&"
export * from "../killist.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports